import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { selectContentTotalLength } from '../../../selectors/ContentSelectors';
import { AppState } from '../../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../../utils/ConnectUtils';
import { AllSitesSpace, AllSitesSpaceDispatchProps, AllSitesSpaceStateProps } from './AllSitesSpace';

const mapStateToProps: MapStateToProps<AllSitesSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedSites: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<AllSitesSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedAllSitesSpace: React.ComponentClass<{}>
  = connect(mapStateToProps, mapDispatchToProps)(AllSitesSpace);
